import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

const PauseButtonIcon = ({ color = '#fff', size = 20, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 426.667 426.667"
    width={size}
    height={size}
    fill={color}
    {...props}
  >
    <path d="M234.667 128h42.667v170.667h-42.667zM149.333 128H192v170.667h-42.667z" />
    <path d="M213.333 0C95.467 0 0 95.467 0 213.333s95.467 213.333 213.333 213.333S426.667 331.2 426.667 213.333 331.2 0 213.333 0zm0 384c-94.08 0-170.667-76.587-170.667-170.667S119.253 42.667 213.333 42.667 384 119.253 384 213.333 307.413 384 213.333 384z" />
  </svg>
);

PauseButtonIcon.propTypes = propTypes;

export default PauseButtonIcon;
